import { DateTime } from 'luxon';
import { MicrotaskType } from '../../enums/microtask-types.enum';
import { ObjectState } from '../../enums/objectState.enum';
import { CommandPayload } from '../../interfaces/commands/command-payload';
import { IDeliveryResponse } from '../../interfaces/commands/delivery-response';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { MicroTaskConfigType } from '../../types/micro-task-config-type';
import { Guid } from '../guid';

export class MicroTaskConfig implements IConfigObjectBase {
	id: string = Guid();
	referenceId: string = Guid();
	version = '1.0.0';
	name = '';
	description = '';
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	taskType: MicrotaskType = MicrotaskType.Unknown;
	taskDisabled = false;
	config?: MicroTaskConfigType;
	sampleData?: CommandPayload | string;
	resultData?: IDeliveryResponse | string;
	objectState?: ObjectState;
	taskColor = 'default';

	constructor(init?: Partial<MicroTaskConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
